import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/ui/ErrorBoundary";
import ProtectedRoute from "./components/layout/ProtectedRoute";

import LandingPage    from "./pages/LandingPage";
import LoginPage      from "./pages/LoginPage";
import DashboardPage  from "./pages/DashboardPage";
import ScreeningPage  from "./pages/ScreeningPage";
import ProfilePage    from "./pages/ProfilePage";
import AdminPage      from "./pages/AdminPage";

function withBoundary(element) {
  return <ErrorBoundary>{element}</ErrorBoundary>;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: withBoundary(<LandingPage />),
  },
  {
    path: "/login",
    element: withBoundary(<LoginPage />),
  },
  {
    path: "/dashboard",
    element: withBoundary(
      <ProtectedRoute>
        <DashboardPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/screening",
    element: withBoundary(
      <ProtectedRoute>
        <ScreeningPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/profile",
    element: withBoundary(
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin",
    element: withBoundary(
      <ProtectedRoute requireAdmin>
        <AdminPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

export default router;
